import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const tabClasses = generateUtilityClasses('Tab', [
  'item', // 고정 클래스 - target으로 적용
  'itemLabel', // 고정 클래스 - target으로 적용
  'itemCount', // 고정 클래스 - target으로 적용 (기존 하위 호환성을 위해 유지)
  'itemEndAdornment', // 고정 클래스 - target으로 적용
  'itemInfoButton', // 고정 클래스 - target으로 적용
]);

// ✅ themes 객체 완전 제거 - export하지 않음
